import { render } from "./MemberGetPoint.vue?vue&type=template&id=13a348c4&scoped=true"
import script from "./MemberGetPoint.vue?vue&type=script&lang=js"
export * from "./MemberGetPoint.vue?vue&type=script&lang=js"

import "./MemberGetPoint.vue?vue&type=style&index=0&id=13a348c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13a348c4"

export default script